import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { DeletionPeriodViewModel } from "./DeletionPeriods.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useDeletionPeriodsHooks() {
    const queryClient = useDotLegalQueryClient();
    const [showAllDeletionsPeriods, setShowAllDeletionsPeriods] = useStateLocalStorage("onlyActiveDeletionPeriods", false);
    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [showDeleteDeletionPeriodDialog, setShowDeleteDeletionPeriodDialog] = useState(false);
    const [selectedDeletionPeriod, setSelectedDeletionPeriod] = useState<DeletionPeriodViewModel | undefined>(undefined);
    const [showChangeStatusDialog, setShowChangeStausDialog] = useState(false);

    const queryPart = `?showAllDeletionPeriod=${showAllDeletionsPeriods}`;
    const url = `/deletion-periods${queryPart}`;
    const { isLoading, data } = useDotLegalQuery<Array<DeletionPeriodViewModel>>(url);

    let deletionPeriods;
    if (data) {
        deletionPeriods = data.map((dp) => {
            return {
                id: dp.id,
                name: dp.name,
                description: dp.description,
                deletionPeriodType: dp.deletionPeriodType,
                deletionPeriodLength: dp.deletionPeriodLength,
                active: dp.active,
                isCustom: dp.isCustom,
            };
        });
    }

    const refetchDeletionPeriods = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        deletionPeriods,
        showAllDeletionsPeriods,
        setShowAllDeletionsPeriods,
        showAddEditDialog,
        setShowAddEditDialog,
        showDeleteDeletionPeriodDialog,
        setShowDeleteDeletionPeriodDialog,
        selectedDeletionPeriod,
        setSelectedDeletionPeriod,
        refetchDeletionPeriods,
        showChangeStatusDialog,
        setShowChangeStausDialog,
    };
}
